import { settingsT } from '~/composables/hr-evaluation/conf/settings/useHrEvalSettingsI18n';

/** 평가설정 불러오기 — 레거시 hreConfMng 템플릿 목록 (templateTypeCd 001~005) */
export type EvalSettingsTemplateId = '001' | '002' | '003' | '004' | '005';

export type EvalSettingsTemplatePreviewTab = 'perform' | 'ability';

export interface EvalSettingsTemplateDef {
  id: EvalSettingsTemplateId;
  label: string;
  description: string;
  evalCycleNm: string;
  hasPerform: boolean;
  hasAbility: boolean;
  preview: Partial<Record<EvalSettingsTemplatePreviewTab, string>>;
}

type EvalSettingsTemplateMeta = {
  id: EvalSettingsTemplateId;
  labelKey: string;
  descriptionKey: string;
  evalCycleNmKey: string;
  hasPerform: boolean;
  hasAbility: boolean;
  preview: Partial<Record<EvalSettingsTemplatePreviewTab, string>>;
};

const previewBase = '/images/template-preview';

const EVAL_SETTINGS_TEMPLATE_META: EvalSettingsTemplateMeta[] = [
  {
    id: '001',
    labelKey: 'm_7f69bc4f72',
    descriptionKey: 'm_ad6563240a',
    evalCycleNmKey: 'm_7f69bc4f72',
    hasPerform: false,
    hasAbility: true,
    preview: {
      ability: `${previewBase}/001-ability.png`,
    },
  },
  {
    id: '002',
    labelKey: 'm_6959c3d13b',
    descriptionKey: 'm_da3913235e',
    evalCycleNmKey: 'm_6959c3d13b',
    hasPerform: true,
    hasAbility: false,
    preview: {
      perform: `${previewBase}/002-perform.png`,
    },
  },
  {
    id: '003',
    labelKey: 'm_131bd158c9',
    descriptionKey: 'm_21da77b625',
    evalCycleNmKey: 'm_0b67947742',
    hasPerform: true,
    hasAbility: true,
    preview: {
      perform: `${previewBase}/003-perform.png`,
      ability: `${previewBase}/003-ability.png`,
    },
  },
  {
    id: '004',
    labelKey: 'm_c6f1598b73',
    descriptionKey: 'm_b8b75235bc',
    evalCycleNmKey: 'm_c6f1598b73',
    hasPerform: true,
    hasAbility: false,
    preview: {
      perform: `${previewBase}/004-perform.png`,
    },
  },
  {
    id: '005',
    labelKey: 'm_b1c3612297',
    descriptionKey: 'm_456d46022c',
    evalCycleNmKey: 'm_b59b0ab270',
    hasPerform: true,
    hasAbility: true,
    preview: {
      perform: `${previewBase}/005-perform.png`,
      ability: `${previewBase}/005-ability.png`,
    },
  },
];

const resolveTemplateDef = (meta: EvalSettingsTemplateMeta): EvalSettingsTemplateDef => ({
  id: meta.id,
  label: settingsT(meta.labelKey),
  description: settingsT(meta.descriptionKey),
  evalCycleNm: settingsT(meta.evalCycleNmKey),
  hasPerform: meta.hasPerform,
  hasAbility: meta.hasAbility,
  preview: meta.preview,
});

/** 현재 locale 기준 템플릿 목록 (호출 시점에 번역) */
export const getEvalSettingsTemplateList = (): EvalSettingsTemplateDef[] =>
  EVAL_SETTINGS_TEMPLATE_META.map(resolveTemplateDef);

export const getEvalSettingsTemplateDef = (templateId: string): EvalSettingsTemplateDef | undefined =>
  getEvalSettingsTemplateList().find(t => t.id === String(templateId));

export const getEvalSettingsTemplateEvalCycleNm = (templateId: string) =>
  getEvalSettingsTemplateDef(templateId)?.evalCycleNm ?? settingsT('wizard.defaultEvalCycleNm');

/** 미리보기(?) 버튼 툴팁 */
export const getEvalSettingsTemplatePreviewTooltip = (templateId: string) => {
  const def = getEvalSettingsTemplateDef(templateId);
  if (!def?.label) return settingsT('templates.previewDefault');
  return settingsT('misc.previewWithLabel', { label: def.label });
};
